import { Storage, API, graphqlOperation } from "aws-amplify"
import axios from "axios"
import {
	putReportFile,
	deleteReportFile,
	// uploadFile,
	createSignS3
} from "../graphql/mutation"
export const helperObjectToquert = (obj) => {
	if (obj) {
		let query = ""
		Object.keys(obj).forEach((key) => {
			query += `${key}: ${
				key === "soft_deleted" || key === "user_id"
					? '"' + obj[key] + '"'
					: obj[key]
			}, `
		})
		if (query.length <= 0) {
			return null
		}
		return `{${query}}`
	}
	return null
}

export const helperObjectToquerthistory = (obj) => {
	if (obj) {
		let query = ""
		Object.keys(obj).forEach((key) => {
			query += `${key}: ${
				key === "subject_id" || key === "history_action"
					? '"' + obj[key] + '"'
					: obj[key]
			}, `
		})
		if (query.length <= 0) {
			return null
		}
		return `{${query}}`
	}
	return null
}
export const helperObjectToquertnotification = (obj) => {
	if (obj) {
		let query = ""
		Object.keys(obj).forEach((key) => {
			query += `${key}: ${
				key === "user_id" ||
				key === "notification_id" ||
				key === "notification_title" ||
				key === "notification_type"
					? '"' + obj[key] + '"'
					: obj[key]
			}, `
		})
		if (query.length <= 0) {
			return null
		}
		return `{${query}}`
	}
	return null
}
export const helperArrayKeyword = (obj) => {
	if (obj) {
		let query = ""
		obj.forEach((item, i) => {
			query += `${'"' + item + '"'},`
		})
		if (query.length <= 0) {
			return []
		}
		query = query.substring(0, query.length - 1)
		return `[${query}]`
	}
	return []
}
export const checkDupArray = (old_array, new_array) => {
	if (!!new_array) {
		new_array.forEach((element) => {
			if (!old_array.some((data) => data.project_id === element.project_id)) {
				old_array.push(element)
			}
		})
	}
	return old_array
}
export const checkDupArrayComment = (old_array, new_array) => {
	if (!!new_array) {
		new_array.forEach((element) => {
			if (!old_array.some((data) => data.comment_id === element.comment_id)) {
				old_array.push(element)
			}
		})
	}
	return old_array
}
export const checkDupArrayBlogs = (old_array, new_array) => {
	if (!!new_array) {
		old_array.forEach((element) => {
			if (new_array.blog_id !== element.blog_id) {
				old_array.push(new_array)
			}
		})
	}
	return old_array
}
export const checkDupArrayHistory = (old_array, new_array) => {
	if (!!new_array) {
		new_array.forEach((element) => {
			if (
				!old_array.some(
					(data) => data.target_action === element.target_action
				) &&
				(element.history_detail === "createProject" ||
					element.history_detail === "updateProject")
			) {
				old_array.push(element)
			}
		})
	}
	return old_array
}
export const checkDupArraynotification = (old_array, new_array) => {
	if (!!new_array) {
		new_array.forEach((element) => {
			if (
				!old_array.some(
					(data) => data.notification_id === element.notification_id
				)
			) {
				old_array.push(element)
			}
		})
	}
	return old_array
}

const toBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = () => resolve(reader.result)
		reader.onerror = (error) => reject(error)
	})
}
const uploadfile = (result, value, filePath) => {
	return new Promise((resolve, reject) => {
		resolve(
			API.graphql(
				graphqlOperation(
					createSignS3({
						access_level: "public",
						// body: result,
						filename: value.name,
						path: filePath,
						mime: value.type
					})
				)
			)
		)
	})
}
export const uploadToS3 = async (file, signedRequest) => {
	const options = { headers: { "Content-Type": file.type } }
	return await axios.put(signedRequest, file, options).then((res) => res)
}
export const putReport = async (project_id, value) => {
	let filePath = `project/report/${project_id}`
	await toBase64(value)
		.then((result) => {
			let file64 = result.split(",")
			return uploadfile(file64[1], value, filePath)
		})
		.then(async (data) => {
			let result1 = JSON.parse(data.data.createSignS3.body)
			await uploadToS3(value, result1.signedRequest)
			await API.graphql(
				graphqlOperation(
					putReportFile({
						product_name: value.name,
						price: 100, //have change
						project_id,
						full_report_url: result1.file_path,
						preview_report_url: result1.file_path
					})
				)
			)
		})
		.catch((err) => {})
}

export const deleteReport = async (product) => {
	let filePath = `project/report/${product.project_id}/${product.product_name}`
	await Storage.remove(filePath, {
		level: "protected"
	})
	await API.graphql(graphqlOperation(deleteReportFile(product.product_id)))
}
